import React from 'react';
import './VendorPage.css';

import { PageTitle, PagesNo, EmptyState, ShowcaseHeader, Vendor } from '../../../components';
import { useFilterLoading, useVendorFilter } from '../../../utils';

import { FaStore } from 'react-icons/fa';



const VendorPage = () => {  

  // Fetch filtered and paginated vendor data using the custom hook `useVendorFilter`
  const {
    searchKeyword,      // Current search keyword
    matchingVendors,    // List of vendors matching the search and filters
    sortOption,         // Current sorting option
    handleSort,         // Function to handle sorting changes
    currentPage,        // Current page number
    displayedVendors,   // Function to handle search form submission
    totalPages,         // Total number of pages
    handlePageChange,   // Function to handle page change in pagination
  } = useVendorFilter();

  // Use the custom hook `useFilterLoading` to determine if filtering is in progress
  const isFiltering = useFilterLoading(matchingVendors, searchKeyword);

  return (  
    <div className='vendors-page'> 

      {/* Page title */}
      <PageTitle title={'Vendors'} page={'Vendors'} />

      <section className='vendors'>

        {/* Check if there are matching vendors */}
        {isFiltering ? null : matchingVendors.length === 0 ? (
          <EmptyState
            icon={FaStore} 
            title="No Vendors Found" 
            message="We couldn’t find any vendors matching your search." 
            buttonLink="Vendors" 
            buttonText="Explore All Vendors" 
          />
          ) : (
          <>

            {/* Vendor header component */}
            <ShowcaseHeader
              showing={displayedVendors.length}
              total={matchingVendors.length}
              sortOption={sortOption}
              handleSort={handleSort}
              isVendor={true}
            />

            {/* Vendors Container */}
            <div className='box-container'>
              {/* Render each Vendor component */}
              {displayedVendors.map((vendor) => {
                return( 
                  <Vendor key={vendor.id} vendor={vendor} />
                )
              })
              }
            </div>

            {/* pagination component */}
            <PagesNo currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />

          </>
        )}

      </section>

    </div>
  );
}

export default VendorPage;